import React, { useEffect, useState, useRef } from "react";
import InputField from "./components/InputField";
import TodoList from "./components/TodoList";
import { DragDropContext, DropResult } from "react-beautiful-dnd";
import { Todo } from "./models/models";
import { Logs } from "./models/logs";
import firebase from "../../firebase";
import moment from 'moment';
import Trello from './components/Trello';
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push } from "firebase/database";

const PageTODO: React.FC = () => {
  const [todo, setTodo] = useState<string>("");
  const [todos, setTodos] = useState<Array<Todo>>([]);
  const [CompletedTodos, setCompletedTodos] = useState<Array<Todo>>([]);
  const [InProgressTodos, setInProgressTodos] = useState<Array<Todo>>([]);
  const [showTrello, setShowTrello] = useState(false);
  const [count,setCount] = useState(0);
  const countRef = useRef(0);
  const db = getDatabase();

  useEffect(() => {

    var curtime = moment().format("DD/MM/YYYY HH:mm:ss");

      get(ref(db,'/logs')).then((snapshot) => {
      var newCount = 0;
      snapshot.forEach(child => {
        newCount = newCount + 1;
      });
      setCount(newCount);
      //setCountFunc(newCount);
    });
    /*setTimeout(function(){ 
      console.log("Count is gg:"+count);
    }, 1000);*/

    var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
    /*var refdb = firebase.database().ref('/tasks').push();
        refdb = refdb.toString().slice(-20);
        let updateData = firebase.database().ref("/tasks").child(refdb);
        updateData.child("id").set(1);
        updateData.child("email").set(localStorage.getItem('user_id'));
        updateData.child("title").set("test");
        updateData.child("description").set("Description of test");
        updateData.child("status").set(0);
        updateData.child("created_at").set(curtime);
        updateData.child("updated_at").set(curtime);*/
    
        get(ref(db,'/tasks')).then((snapshot) => {
      /*var tasks = {id:0,email:'',title:'',description:'',isInProgress:false,isDone:false,created_at:'',updated_at:''};
      const newTodos = [...todos, tasks];
      snapshot.forEach(child => {
        var data = child.val();
        tasks.push({
          id: parseInt(data.key), 
          email: String(data.email),
          title: String(data.title),
          description: String(data.description),
          isInProgress: false, 
          isDone: false,
          created_at: String(data.created_at),
          updated_at: String(data.updated_at),
        });*/
        //setTodos({...todos, tasks });
        var newTodos = [...todos];
        var newCompletedTodos = [...CompletedTodos];
        var newInProgressTodos = [...InProgressTodos];
        snapshot.forEach(child => {
          var data = child.val();
          //var newTodos = [...todos];
          if((data.isInProgress ==="false")&&(data.isDone ==="false")){
            newTodos = [...newTodos,{
              id: parseInt(data.id), 
              email: String(data.email),
              title: String(data.title),
              description: String(data.description),
              isInProgress: (data.isInProgress ==="true"),
              isDone: (data.isDone ==="true"),
              created_at: String(data.created_at),
              updated_at: String(data.updated_at),
            }];
          }
          if((data.isInProgress ==="true")&&(data.isDone ==="false")){
            newInProgressTodos = [...newInProgressTodos,{
              id: parseInt(data.id), 
              email: String(data.email),
              title: String(data.title),
              description: String(data.description),
              isInProgress: (data.isInProgress ==="true"),
              isDone: (data.isDone ==="true"),
              created_at: String(data.created_at),
              updated_at: String(data.updated_at),
            }];
          }
          if((data.isInProgress ==="false")&&(data.isDone ==="true")){
            newCompletedTodos = [...newCompletedTodos,{
              id: parseInt(data.id), 
              email: String(data.email),
              title: String(data.title),
              description: String(data.description),
              isInProgress: (data.isInProgress ==="true"),
              isDone: (data.isDone ==="true"),
              created_at: String(data.created_at),
              updated_at: String(data.updated_at),
            }];
          }
        });
        setTodos((todos)=>newTodos);
        setCompletedTodos((CompletedTodos)=>newCompletedTodos);
        setInProgressTodos((InProgressTodos)=>newInProgressTodos);
        
        //setTodos([tasks]);
        //console.log(tasks);
        //console.log(newTodos);
        //console.log(todos);
    });
    
  },[]);
  //console.log("Count outside:",count);
  countRef.current = count;
  
  useEffect(()=>{
      var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
      //var refdb_ref:string;
      var refdb = push(ref(db,'logs'));
      //refdb_ref = refdb.toString().slice(-20);
      
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((dataipres) => {
          //let updateData = ref(db,"logs/"+refdb);
          set(refdb,{
            id:countRef.current+1,
            status:'1',
            message:'User Access TODO Page',
            agent:String(navigator.userAgent),
            ip: String(dataipres.ip),
            location:String(dataipres.country_name+'#'+dataipres.region),
            user_id:String(localStorage.getItem('user_id')),
            time:String(curtime)
          });
      });
  },[]);

  /*const setCountFunc = (paramCount) => {
    //setCount(paramCount);
    console.log(paramCount);
    setTimeout(function(){ 
      console.log(countRef.current);
    }, 1000);
  }*/

  const handleAdd = (e: React.FormEvent) => {
    e.preventDefault();

    if (todo) {
      const curtime = moment().format("DD/MM/YYYY HH:mm:ss");
      var id = Number(todos.length+1);
      const newTodos = [...todos, { id: id, title: String(todo), email: String(localStorage.getItem('user_id')), description: String(todo) , isInProgress: false, isDone: false, created_at: String(curtime) ,updated_at: String(curtime) }];
      var refdb_ref: string ='';
      var refdb = push(ref(db,'/tasks'));

        let updateData = ref(db,"/tasks"+refdb);
        set(updateData,{id:id});
        set(updateData,{email:localStorage.getItem('user_id')});
        set(updateData,{title:String(todo)});
        set(updateData,{description:"Description of "+String(todo)});
        set(updateData,{isInProgress:String("false")});
        set(updateData,{isDone:String("false")});
        set(updateData,{created_at:curtime});
        set(updateData,{updated_at:curtime});
      setTodos(newTodos);
      setTodo("");
    }
  };

  const onDragEnd = (result: DropResult) => {
    const { destination, source } = result;

    console.log(result);

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    let add;
    let active = todos;
    let inprogress = InProgressTodos;
    let complete = CompletedTodos;
    // Source Logic
    if (source.droppableId === "TodosList") {
      //alert(active[source.index].id);
      var todo_active = active[source.index].id;
      add = active[source.index];
      active.splice(source.index, 1);
      
      var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
      get(ref(db,"/tasks")).then((snapshot) => {
        snapshot.forEach(child => {
          var data = child.val();
          if(data.id === todo_active){
            const chil_ref = child.key?child.key:'';
            update(ref(db,"/tasks"+chil_ref),{isInProgress:"true",isDone:"false",updated_at:curtime}).then(() => {
            }).catch(error => {
              return {
                errorCode: error.code,
                errorMessage: error.message
              }
            });
          }
        });
      });
    } else if (source.droppableId === "TodosInProgress") {
      var todo_active_pr = inprogress[source.index].id;
      add = inprogress[source.index];
      inprogress.splice(source.index, 1);
      //alert(source.index);
      var curtime_pr = moment().format("DD/MM/YYYY HH:mm:ss");
      get(ref(db,"/tasks")).then((snapshot) => {
        snapshot.forEach(child => {
          var data = child.val();
          if(data.id === todo_active_pr){
            const chil_ref = child.key?child.key:'';
            update(ref(db,"/tasks"+chil_ref),{isInProgress:"false",isDone:"false",updated_at:curtime_pr}).then(() => {
            }).catch(error => {
              return {
                errorCode: error.code,
                errorMessage: error.message
              }
            });
          }
        });
      });
    }  else {
      var todo_active_co = complete[source.index].id;
      add = complete[source.index];
      complete.splice(source.index, 1);
      var curtime_co = moment().format("DD/MM/YYYY HH:mm:ss");
      get(ref(db,"/tasks")).then((snapshot) => {
        snapshot.forEach(child => {
          var data = child.val();
          if(data.id === todo_active_co){
            const chil_ref = child.key?child.key:'';
            update(ref(db,"/tasks"+chil_ref),{isInProgress:"false",isDone:"false",updated_at:curtime_co}).then(() => {
            }).catch(error => {
              return {
                errorCode: error.code,
                errorMessage: error.message
              }
            });
          }
        });
      });
    }

    // Destination Logic
    if (destination.droppableId === "TodosList") {
      active.splice(destination.index, 0, add);
    } else if (destination.droppableId === "TodosInProgress") {
      inprogress.splice(destination.index, 0, add);
    }  else {
      complete.splice(destination.index, 0, add);
    }

    setCompletedTodos(complete);
    setInProgressTodos(inprogress);
    setTodos(active);
  };

  function handleShowTrello(){
    setShowTrello((showTrello)=>!showTrello);
  }

  return (
    <>
    <div className="float-right"><button className="btn btn-primary" onClick={()=>handleShowTrello() } style={{boxShadow: '0 0 10px black',borderRadius:'15px'}}>Switch</button></div>
    {showTrello&&(<div className="trello"><Trello/></div>)}
    {!showTrello&&(<DragDropContext onDragEnd={onDragEnd}>
      <div className="App">
        <span className="heading"><strong>TODO</strong></span>
        <InputField todo={todo} setTodo={setTodo} handleAdd={handleAdd} />
        <TodoList
          todos={todos}
          setTodos={setTodos}
          CompletedTodos={CompletedTodos}
          setCompletedTodos={setCompletedTodos}
          InProgressTodos={InProgressTodos}
          setInProgressTodos={setInProgressTodos}
        />
      </div>
    </DragDropContext>)}
    </>
  );
};

export default PageTODO;
